import React, { use } from "react";
import "./JobDetails.css";
import styled from "styled-components";
import { useEffect, useState, useCallback } from "react";
import { fetchStyle } from "../Config/config";
import { BaseUrl } from "../UserData";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as pdfjsLib from "pdfjs-dist";
import mammoth from "mammoth";
// import { GlobalWorkerOptions } from 'pdfjs-dist/legacy/build/pdf.mjs';
import 'pdfjs-dist/build/pdf.worker.mjs'
// GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/legacy/build/pdf.worker.min.mjs', import.meta.url).toString();
// // Configure PDF.js worker for version 5.x - CRITICAL for PDF parsing
// pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

// Move these outside the component
const ThemeWrapper = styled.div`
  background-color: ${(props) => props.theme.bg_color};

  /* Define global CSS variables */
  --text-color: ${(props) => props.theme.text_color || "#333"};
  --text-font: ${(props) => props.theme.text_font || "Arial, sans-serif"};

  --button-bg: ${(props) => props.theme.button_color || "#0073e6"};

  --bg-color: ${(props) => props.theme.bg_color || "#ffffff"};
  font-family: var(--text-font);
  color: var(--text-color);
  background-color: var(--bg-color);
`;

const Button = styled.button`
  background-color: var(--button-bg);
  color: #fff;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  border-radius:6px;
  transition: background-color 0.3s ease-in-out;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const Popup = styled.div`
  background: #fff;
  padding: 30px 40px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: 90%;
`;

const PopupTitle = styled.h2`
  color: #333;
  margin-bottom: 12px;
`;

const PopupText = styled.p`
  color: #555;
  margin-bottom: 20px;
  font-size: 16px;
`;

const CloseButton = styled.button`
  background: #005bb5;
  color: white;
  border: none;
  padding: 10px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 15px;
  transition: 0.3s;
  &:hover {
    background: #005bb5;
  }
`;


const JobDetails = ({
  jobDetails,
  customernameFromUrl,
  handleBackToListings,
  isListView,
  renderHTML,
  isLongContent,
  department,
  city,
  state,
  country,
  job_id,
}) => {
  const [theme, setTheme] = useState({});
  const styleApiUrl = `${BaseUrl}/customer/getEmbededCodeSettings?customerName=${customernameFromUrl}`;
  useEffect(() => {
    const fetchThemes = async () => {
      if (
        customernameFromUrl === "undefined" ||
        customernameFromUrl === undefined
      )
        return;
      const fetchedTheme = await fetchStyle(styleApiUrl);
    
      setTheme(fetchedTheme);
    };
    fetchThemes();
  }, [customernameFromUrl]);
  const [search] = useSearchParams();
  const [data, setdata] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [showApplyForm, setShowApplyForm] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [duplicateError, setDuplicateError] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
const [alreadyApplied, setAlreadyApplied] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    experience: "",
    contactnumber: "",
    country: "",
    state: "",
    city: "",
    resume: null,
  });

  const navigate = useNavigate();

//   useEffect(() => {
//   if (typeof window !== 'undefined') {
//     pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/5.4.296/pdf.worker.min.mjs';
//     console.log('✅ PDF.js worker configured for v5.x:', pdfjsLib.GlobalWorkerOptions.workerSrc);
//   }
// }, []);

  const handleApplyClick = () => {
    setShowApplyForm(true);
  };

  const handleCloseForm = () => {
    setShowApplyForm(false);
  };

  const handleFormChange = useCallback((field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  }, []);

  // handle resume upload
  const handleResumeUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        resume: file,
      }));
    }
  };

  const handleSubmitApplication = async () => {
    if (!formData.firstName.trim()) return alert("First Name is required");
    if (!formData.lastName.trim()) return alert("Last Name is required");
    if (!formData.country) return alert("Country is required");
    if (!formData.resume) return alert("Resume is required");
    if (!formData.email.trim()) { return alert("Email is required");}
    if (!formData.contactnumber.trim()) {return alert("Contact Number is required");}

    try {
      // Get job_id from props or URL params
      const jobIdToUse = job_id || search.get("jobid");
      const customerNameToUse = customernameFromUrl;

      if (!jobIdToUse || !customerNameToUse) {
        alert("Missing job ID or customer name. Please try again.");
        console.error("Missing params:", { jobIdToUse, customerNameToUse });
        return;
      }

      const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file); // Reads full base64 Data URL
          reader.onload = () => resolve(reader.result); // Keep "data:...;base64,..." part
          reader.onerror = (error) => reject(error);
        });
      const resumeBase64 = await fileToBase64(formData.resume);

      const dataToSend = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        email_id: formData.email,
        experience: formData.experience,
        country_code: countryCode,
        contact_number: formData.contactnumber,
        country: formData.country,
        state: formData.state,
        city: formData.city,
        resume: resumeBase64,
      };

      console.log(
        "Submitting to:",
        `${BaseUrl}/customer/ApplyJobFromCandidate?customerName=${customerNameToUse}&job_id=${jobIdToUse}`
      );

      const response = await fetch(
        `${BaseUrl}/customer/ApplyJobFromCandidate?customerName=${encodeURIComponent(
          customerNameToUse
        )}&job_id=${jobIdToUse}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(dataToSend),
        }
      );

      // Check if response is JSON before parsing
      const contentType = response.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        const text = await response.text();
        console.error("Non-JSON response received:", text);
        throw new Error(
          "Server returned an invalid response. Please check the API endpoint."
        );
      }

      const responseData = await response.json();

      if (response.ok) {
        setShowPopup(true);
       
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          experience: "",
          contactnumber: "",
          country: "",
          state: "",
          city: "",
          resume: null,
        });
        setShowApplyForm(false);
      } else {
        alert(
          responseData.message ||
            "Failed to submit application. Please try again."
        );
      }
    } catch (error) {
      console.error("Error submitting application:", error);
      alert(
        error.message ||
          "An error occurred while submitting the application. Please try again."
      );
    }
  };

  const checkDuplicateApplication = async (email, contact) => {
  const jobIdToUse = job_id || search.get("jobid");

  if (!email || !contact || !jobIdToUse) {
    setDuplicateError("");
    setAlreadyApplied(false);
    return;
  }

  try {
    const response = await fetch(
      `${BaseUrl}/customer/checkDuplicateApplication?customerName=${encodeURIComponent(
        customernameFromUrl
      )}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          job_id: jobIdToUse,
          email_id: email,
          contact_number: contact,
        }),
      }
    );

    const data = await response.json();

    if (data.alreadyApplied) {
      setDuplicateError("You have already applied for this job.");
      setAlreadyApplied(true);
    } else {
      setDuplicateError("");
      setAlreadyApplied(false);
    }
  } catch (err) {
    console.error(err);
  }
};


  useEffect(() => {
  const apply = search.get("apply");
  if (apply === "true") {
    setShowApplyForm(true);
  }
}, []);

useEffect(() => {
  if (search.get("apply") === "true") {
    setShowApplyForm(true);
  }
}, [search]);
 
  const handleAutoFill = async () => {
  if (!formData.resume) {
    alert("Please upload a resume first");
    return;
  }

  const file = formData.resume;
  let text = "";

  try {
    console.log("File type:", file.type);
    console.log("File name:", file.name);
    console.log("File size:", file.size);

    // TXT
    if (file.type === "text/plain") {
      console.log("Processing as TXT...");
      text = await file.text();
    }
    // PDF
    else if (file.type === "application/pdf") {
      console.log("Processing as PDF...");
      
      // Check if pdfjsLib is loaded
      if (typeof pdfjsLib === 'undefined') {
        throw new Error("PDF.js library is not loaded. Please add the script tag.");
      }
      
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
      
 
      
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join(" ");
        text += pageText + "\n";
      }
    }
    // DOCX
    else if (
      file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
      file.name.endsWith(".docx")
    ) {
    
      
      // Check if mammoth is loaded
      if (typeof mammoth === 'undefined') {
        throw new Error("Mammoth library is not loaded. Please add the script tag.");
      }
      
      const arrayBuffer = await file.arrayBuffer();
      const result = await mammoth.extractRawText({ arrayBuffer });
      text = result.value;
    } else {
      alert(`Unsupported file format: ${file.type}. Please upload PDF, DOCX, or TXT file.`);
      return;
    }



    if (!text || text.trim().length === 0) {
      throw new Error("No text could be extracted from the file");
    }

    // Enhanced extraction with better patterns
    
    // Email extraction
    const emailMatch = text.match(/[\w.+-]+@[\w-]+\.[\w.-]+/);
    
    // Phone extraction (multiple formats including international)
    const phoneMatch = text.match(/(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}/);
    
    // Name extraction - try multiple patterns
    let firstName = "";
    let lastName = "";
    
    // Pattern 1: Look for explicit "Name:" label
    const namePattern1 = text.match(/(?:Name|Full Name|Candidate Name)[:\s-]+([A-Z][a-zA-Z]+(?:\s+[A-Z][a-zA-Z]+)*)/i);
    if (namePattern1) {
      const fullName = namePattern1[1].trim().split(/\s+/);
      firstName = fullName[0];
      lastName = fullName.slice(1).join(" ");
      
    } 
    
    // Pattern 2: First line that looks like a name (more flexible)
    if (!firstName) {
      const lines = text.split('\n').filter(line => line.trim().length > 0);
      for (let line of lines.slice(0, 10)) {
        const trimmed = line.trim();
        // More flexible: 2-4 words, starts with capital, 3-40 chars, no @ or numbers
        if (
          trimmed.length >= 3 && 
          trimmed.length <= 40 && 
          /^[A-Z]/.test(trimmed) &&
          !trimmed.includes('@') &&
          !trimmed.includes('http') &&
          !/\d{2,}/.test(trimmed) && // No consecutive numbers
          trimmed.split(/\s+/).length >= 2 &&
          trimmed.split(/\s+/).length <= 4
        ) {
          const parts = trimmed.split(/\s+/);
          // Validate each part starts with capital
          if (parts.every(part => /^[A-Z]/.test(part))) {
            firstName = parts[0];
            lastName = parts.slice(1).join(" ");
          
            break;
          }
        }
      }
    }
    
    // Pattern 3: Look for pattern "FirstName LastName" near email
    if (!firstName && emailMatch) {
      const emailIndex = text.indexOf(emailMatch[0]);
      const beforeEmail = text.substring(Math.max(0, emailIndex - 100), emailIndex);
      const nameMatch = beforeEmail.match(/([A-Z][a-z]+\s+[A-Z][a-z]+)(?=\s|$)/);
      if (nameMatch) {
        const parts = nameMatch[1].split(/\s+/);
        firstName = parts[0];
        lastName = parts.slice(1).join(" ");
      
      }
    }
    
    // Pattern 4: Try all capitalized words at the beginning
    if (!firstName) {
      const allCapsMatch = text.match(/^([A-Z]+\s+[A-Z]+)/m);
      if (allCapsMatch) {
        const parts = allCapsMatch[1].split(/\s+/);
        if (parts.length === 2) {
          firstName = parts[0].charAt(0) + parts[0].slice(1).toLowerCase();
          lastName = parts[1].charAt(0) + parts[1].slice(1).toLowerCase();
          
        }
      }
    }
    
    // City extraction
    const cityPattern = text.match(/(?:City[:\s]+)([A-Za-z\s]+?)(?:\n|,|\||$)/i);
    let city = "";
    if (cityPattern) {
      city = cityPattern[1].trim();
    } else {
      // Look for common city names
      const commonCities = [
        'Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Chennai', 'Kolkata', 'Pune', 'Ahmedabad',
        'New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix', 'San Francisco', 'Seattle',
        'London', 'Manchester', 'Birmingham', 'Edinburgh', 'Toronto', 'Vancouver', 'Montreal',
        'Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Singapore', 'Dubai', 'Abu Dhabi'
      ];
      
      for (let cityName of commonCities) {
        const regex = new RegExp(`\\b${cityName}\\b`, 'i');
        if (regex.test(text)) {
          city = cityName;
          break;
        }
      }
    }
    
    // Country extraction
    const countryPattern = text.match(/(?:Country[:\s]+)([A-Za-z\s]+?)(?:\n|,|\||$)/i);
    let country = "";
    if (countryPattern) {
      country = countryPattern[1].trim();
    } else {
      // Look for common country names
      const commonCountries = [
        'India', 'United States', 'USA', 'United Kingdom', 'UK', 'Canada', 'Australia',
        'Germany', 'France', 'Singapore', 'UAE', 'United Arab Emirates', 'China', 'Japan'
      ];
      
      for (let countryName of commonCountries) {
        const regex = new RegExp(`\\b${countryName}\\b`, 'i');
        if (regex.test(text)) {
          country = countryName;
          // Normalize country names
          if (country.toLowerCase() === 'usa') country = 'United States';
          if (country.toLowerCase() === 'uk') country = 'United Kingdom';
          if (country.toLowerCase() === 'uae') country = 'United Arab Emirates';
          break;
        }
      }
    }
    
    // State extraction
    const statePattern = text.match(/(?:State[:\s]+)([A-Za-z\s]+?)(?:\n|,|\||$)/i);
    let state = "";
    if (statePattern) {
      state = statePattern[1].trim();
    } else {
      // Look for common US states
      const usStates = [
        'California', 'Texas', 'Florida', 'New York', 'Pennsylvania', 'Illinois', 'Ohio',
        'Georgia', 'North Carolina', 'Michigan', 'Massachusetts', 'Washington', 'Arizona'
      ];
      
      // Look for common Indian states
      const indianStates = [
        'Maharashtra', 'Karnataka', 'Tamil Nadu', 'Telangana', 'Gujarat', 'Rajasthan',
        'Uttar Pradesh', 'West Bengal', 'Kerala', 'Madhya Pradesh', 'Delhi', 'Haryana'
      ];
      
      const allStates = [...usStates, ...indianStates];
      
      for (let stateName of allStates) {
        const regex = new RegExp(`\\b${stateName}\\b`, 'i');
        if (regex.test(text)) {
          state = stateName;
          break;
        }
      }
    }


    // Update form data with extracted information
    setFormData((prev) => ({
      ...prev,
      email: emailMatch ? emailMatch[0] : prev.email,
      contactnumber: phoneMatch ? phoneMatch[0].replace(/\s/g, "") : prev.contactnumber,
      firstName: firstName || prev.firstName,
      lastName: lastName || prev.lastName,
      city: city || prev.city,
      country: country || prev.country,
      state: state || prev.state,
    }));

    alert("Auto-fill completed! Please verify the details.");
    
  } catch (error) {
    console.error("Error in auto-fill:", error);
    console.error("Error stack:", error.stack);
    alert(`Failed to parse resume: ${error.message}. Please check console for details.`);
  }
};
const fetchCountryList = async () => {
    try {
      const response = await fetch(`${BaseUrl}/getCountryList`);
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
    
      return data; // { status: true, message: [...] }
    } catch (error) {
      console.error("Error fetching country list:", error);
      return { status: false, message: [] };
    }
  };

  // Fetch states for a specific country ID
  const fetchStateByCountryId = async (countryId) => {
    if (!countryId) {
  
      return { status: false, message: [] };
    }
    try {
      const response = await fetch(
        `${BaseUrl}/getStateListByCountryId/${countryId}`
      );
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
     
      return data; // { status: true, message: [...] }
    } catch (error) {
      console.error("Error fetching state list:", error);
      return { status: false, message: [] };
    }
  };

  // Example usage
  fetchCountryList().then((countryRes) => {
    // If you get countries, fetch states for the first one as example
    if (countryRes.status && countryRes.message.length > 0) {
      const firstCountryId = countryRes.message[0].id; // adjust according to your API response
      fetchStateByCountryId(firstCountryId);
    }
  });

  useEffect(() => {
    const getCountries = async () => {
      const res = await fetchCountryList();
      if (res.status) {
        setCountryList(res.message); // assuming API returns {id, name}
      }
    };
    getCountries();
  }, []);

  // Fetch states when country changes
  useEffect(() => {
    if (!formData.country) {
      setStateList([]);
      handleFormChange("state", "");
      return;
    }

    const selectedCountry = countryList.find(
      (c) => c.name === formData.country
    );
    if (selectedCountry) {
      fetchStateByCountryId(selectedCountry.id).then((res) => {
        if (res.status) setStateList(res.message);
      });
    }
  }, [formData.country, countryList]);

  const fetchJobByID = async (identifier) => {
    try {
      const response = await fetch(
        `${BaseUrl}/customer/public/getJobById?customerName=${customernameFromUrl}&Jobid=${
          identifier ? identifier : search.get("jobid")
        }`
      );
      const res = await response.json();
    
      if (res.status) {
        setdata(res.message);
      } else {
        setdata([]);
      }
    } catch (err) {
      return "";
    }
  };
  useEffect(() => {
    if (job_id && customernameFromUrl) {
      fetchJobByID(job_id);
    } else if (customernameFromUrl) {
      fetchJobByID(null);
    }
  }, [jobDetails, customernameFromUrl, job_id]);

  const formatDate = (dateString) => {
    if (!dateString) return "No Date Available";
    const date = new Date(dateString);
    return isNaN(date)
      ? dateString
      : date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
  };

  const valueMap = {
    "Job Department": department?.[0]?.department_name,
    City: city?.[0]?.name,
    State: state?.[0]?.name,
    Country: country?.[0]?.name,
  };
  return (
    <>
    <ThemeWrapper
      theme={theme}
      className={`job-detail-container ${isListView ? "list-view" : ""}`}
    >
      <div
        style={{
          display: "flex",
          gap: "10px",
          // justifyContent: isListView ? "flex-end" : "space-between",
          width: "100%",
          marginBottom: "16px",
        }}
      >
        {!isListView && (
          <Button onClick={handleBackToListings} className="back-to-page">
            Back to Listings
          </Button>
        )}

        {!showApplyForm && (
          <button
            className="Apply-btn-iframe"
            onClick={() => {
              if (isListView) {
      
                const jobId = job_id || search.get("jobid");
                const who = search.get("who")
                const whoParam = customernameFromUrl; 
              //  navigate(`/api/iframe/job?who=${encodeURIComponent(who)}&jobid=${jobId}`);
               navigate(
    `/api/iframe/job?who=${encodeURIComponent(who)}&jobid=${jobId}&apply=true`
  );
              } else {
                
                handleApplyClick();
              }
            }}
          >
            Apply
          </button>
        )}
      </div>

      {!showApplyForm ? (
        // Original Job Detail View
        <>
          {data &&
            data.map((section, i) => {
              const filteredValues = section?.values?.filter((item) => {
                const key = Object.keys(item)[0];
                return [
                  "Job Type",
                  "Job Title",
                  "Primary Skills",
                  "City",
                  "Country",
                  "Job Requirements",
                  "Job Description",
                  "Job Benefits",
                ].includes(key);
              });

              if (!filteredValues?.length) return null;

              return (
                <div key={i}>
                  <h3 className="job-detail-section-title">
                    {section?.section}
                  </h3>

                  <div className="job-details-dataa">
                    {filteredValues.map((item, i) => {
                      const [firstKey, firstValue] = Object.entries(item)[0];
                      const [_, secondValue] = Object.entries(item)[1] || [];

                      const displayValue = [
                        "Job Opening Date",
                        "Job Closing Date",
                        "Created At",
                      ].includes(firstKey)
                        ? formatDate(firstValue)
                        : secondValue === "multiselectInput"
                        ? (() => {
                            try {
                              const parsedValue = JSON.parse(firstValue);
                              return Array.isArray(parsedValue)
                                ? parsedValue.map((v) => v.label).join(", ")
                                : firstValue;
                            } catch (error) {
                              return firstValue;
                            }
                          })()
                        : valueMap[firstKey] ?? firstValue;

                      const isDescription =
                        firstKey.toLowerCase().includes("description") ||
                        firstKey.toLowerCase().includes("responsibility") ||
                        firstKey.toLowerCase().includes("requirement") ||
                        firstKey.toLowerCase().includes("benefit");

                      return (
                        <div
                          key={i}
                          className={`job-detail-item ${
                            isDescription ? "description-layout" : ""
                          }`}
                        >
                          <div className="job-detail-label" style={{fontSize:'16px'}}>{firstKey}:</div>
                          <div className="job-detail-value">
                            {secondValue === "editor" ||
                            (typeof displayValue === "string" &&
                              /^<[^>]+>/.test(displayValue)) ? (
                              <div
                                className="job-detail-html-content"
                                dangerouslySetInnerHTML={{
                                  __html: displayValue,
                                }}
                              />
                            ) : (
                              <p className="job-detail-paragraph">
                                {displayValue}
                              </p>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
        </>
      ) : (
        <div className="jd-apply-form-container hide-scrollbars">
          <div className="jd-apply-form-left">
            {/* Upload Resume Section */}
            <div className="jd-form-section">
              <h1 className="jd-form-section-title">Upload Resume</h1>
              <p className="jd-form-description">
                Just a few more steps to finish your application, beginning with
                uploading your resume or linking your LinkedIn profile.
              </p>

              <div className="jd-upload-buttons">
                <label className="jd-upload-btn">
                  <input
                    type="file"
                    accept=".doc,.docx,.html,.pdf,.txt"
                    onChange={handleResumeUpload}
                    style={{ display: "none" }}
                  />
                  📥 Upload Resume
                </label>
                {/* <button onClick={handleAutoFill}  className="jd-auto-fill-btn">🔗 Auto Fill</button> */}
              </div>

              {formData.resume && (
                <p className="jd-file-selected">
                  Selected: {formData.resume.name}
                </p>
              )}
            </div>

            {/* First + Last Name */}
            <div className="jd-form-row">
              <div className="jd-form-group">
                <label className="jd-form-label">First Name *</label>
                <input
                  type="text"
                  className="jd-form-input"
                  placeholder="John"
                  value={formData.firstName}
                  onChange={(e) =>
                    handleFormChange("firstName", e.target.value)
                  }
                />
              </div>

              <div className="jd-form-group">
                <label className="jd-form-label">Last Name *</label>
                <input
                  type="text"
                  className="jd-form-input"
                  placeholder="Doe"
                  value={formData.lastName}
                  onChange={(e) => handleFormChange("lastName", e.target.value)}
                />
              </div>
            </div>

            {/* Email + Experience */}
            <div className="jd-form-row">
              <div className="jd-form-group">
                <label className="jd-form-label">Email *</label>
                <input
                  type="email"
                  className="jd-form-input"
                  placeholder="you@example.com"
                  value={formData.email}
                  onChange={(e) => {
  const value = e.target.value;
  handleFormChange("email", value);
  checkDuplicateApplication(value, formData.contactnumber);
}}
                />
                {duplicateError && (
  <p
    style={{
      color: "red",
      fontSize: "13px",
      marginTop: "5px",
    }}
  >
    {duplicateError}
  </p>
)}
              </div>

              <div className="jd-form-group">
                <label className="jd-form-label">Year Of Experience *</label>
                <input
                  type="text"
                  className="jd-form-input"
                  placeholder="e.g., 5"
                  value={formData.experience}
                  onChange={(e) =>
                    handleFormChange("experience", e.target.value)
                  }
                />
              </div>
            </div>

            {/* Contact Number + City */}
            <div className="jd-form-row">
            <div className="jd-form-group">
  <label className="jd-form-label">Contact Number *</label>

  <div className="custom-contact-wrapper">
    <select
      className="custom-country-code"
      value={countryCode}
      onChange={(e) => {
        setCountryCode(e.target.value);
      }}
    >
      <option value="+91">+91</option>
      <option value="+1">+1</option>
      <option value="+44">+44</option>
      <option value="+61">+61</option>
      <option value="+65">+65</option>
      <option value="+971">+971</option>
      <option value="+81">+81</option>
      <option value="+49">+49</option>
    </select>

    <input
      type="text"
      className="custom-contact-number"
      placeholder="9876543210"
      value={formData.contactnumber}
      onChange={(e) => {
        const value = e.target.value;

        handleFormChange("contactnumber", value);

        checkDuplicateApplication(
          formData.email,
          `${countryCode}${value}`
        );
      }}
    />
  </div>

  {duplicateError && (
    <p className="custom-contact-error">
      {duplicateError}
    </p>
  )}
</div>

              <div className="jd-form-group">
                <label className="jd-form-label">Country *</label>
                <select
                  className="jd-form-select"
                  value={formData.country}
                  onChange={(e) => handleFormChange("country", e.target.value)}
                >
                  <option value="">Select Country</option>
                  {countryList.map((c) => (
                    <option key={c.id} value={c.name}>
                      {c.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Country + State */}
            <div className="jd-form-row">
              <div className="jd-form-group">
                <label className="jd-form-label">State *</label>
                <select
                  className="jd-form-select"
                  value={formData.state}
                  onChange={(e) => handleFormChange("state", e.target.value)}
                  disabled={stateList.length === 0}
                >
                  <option value="">Select State</option>
                  {stateList.map((s) => (
                    <option key={s.id} value={s.name}>
                      {s.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="jd-form-group">
                <label className="jd-form-label">City</label>
                <input
                  type="text"
                  className="jd-form-input"
                  placeholder="City"
                  value={formData.city}
                  onChange={(e) => handleFormChange("city", e.target.value)}
                />
              </div>
            </div>

            {/* Buttons */}
            <div className="jd-form-actions">
 <button
  className={`jd-submit-btn ${alreadyApplied ? "disabled-btn" : ""}`}
  onClick={handleSubmitApplication}
  disabled={alreadyApplied}
>
  Submit
</button>
              <button className="jd-back-btn" onClick={handleBackToListings}>
                Back to Job Details
              </button>
            </div>
          </div>

          {/* Right Side - Job Description (Static) */}
          <div className="jd-apply-form-right">
            <div className="jd-job-description-static">
              {data &&
                data.map((section, i) => {
                  const filteredValues = section?.values?.filter((item) => {
                    const key = Object.keys(item)[0];
                    return [
                      "Job Type",
                      "Job Title",
                      "Primary Skills",
                      "City",
                      "Country",
                      "Job Requirements",
                      "Job Description",
                      "Job Benefits",
                    ].includes(key);
                  });

                  if (!filteredValues?.length) return null;

                  return (
                    <div key={i}>
                      <h3 className="jd-job-detail-section-title">
                        {section?.section}
                      </h3>

                      <div className="jd-job-details-dataa">
                        {filteredValues.map((item, idx) => {
                          const [firstKey, firstValue] =
                            Object.entries(item)[0];
                          const [_, secondValue] =
                            Object.entries(item)[1] || [];

                          const displayValue = [
                            "Job Opening Date",
                            "Job Closing Date",
                            "Created At",
                          ].includes(firstKey)
                            ? formatDate(firstValue)
                            : secondValue === "multiselectInput"
                            ? (() => {
                                try {
                                  const parsedValue = JSON.parse(firstValue);
                                  return Array.isArray(parsedValue)
                                    ? parsedValue.map((v) => v.label).join(", ")
                                    : firstValue;
                                } catch (error) {
                                  return firstValue;
                                }
                              })()
                            : valueMap[firstKey] ?? firstValue;

                          const isDescription =
                            firstKey.toLowerCase().includes("description") ||
                            firstKey.toLowerCase().includes("responsibility") ||
                            firstKey.toLowerCase().includes("requirement") ||
                            firstKey.toLowerCase().includes("benefit");

                          return (
                            <div
                              key={idx}
                              className={`jd-job-detail-item ${
                                isDescription ? "jd-description-layout" : ""
                              }`}
                            >
                              <div className="jd-job-detail-label">
                                {firstKey}:
                              </div>
                              <div className="jd-job-detail-value">
                                {secondValue === "editor" ||
                                (typeof displayValue === "string" &&
                                  /^<[^>]+>/.test(displayValue)) ? (
                                  <div
                                    className="jd-job-detail-html-content"
                                    dangerouslySetInnerHTML={{
                                      __html: displayValue,
                                    }}
                                  />
                                ) : (
                                  <p className="jd-job-detail-paragraph">
                                    {displayValue}
                                  </p>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
            </div>
            
          </div>
        </div>
      )}
    </ThemeWrapper>
    {showPopup && (
      <Overlay>
        <Popup>
          <PopupTitle>Thank You!</PopupTitle>
          <PopupText>Your application has been submitted successfully.</PopupText>
          <CloseButton
  onClick={() => {
    setShowPopup(false);
    if (typeof handleBackToListings === "function") {
      handleBackToListings();
    }
  }}
>
  Close
</CloseButton>
        </Popup>
      </Overlay>
    )}
    </>
    
  );
};

export default JobDetails;
